import React from 'react';

import { Alert } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const CustomAlert = ({ control, name, severity = 'error', sx }) => (
    <Controller
        control={control}
        name={name}
        render={({ fieldState: { error } }) => (
            <>
                {Boolean(error) && (
                    <Alert severity={severity} sx={sx}>
                        {error?.message}
                    </Alert>
                )}
            </>
        )}
    />
);

CustomAlert.propTypes = {
    control: PropTypes.object,
    name: PropTypes.string,
    severity: PropTypes.string,
    sx: PropTypes.object,
};

export default CustomAlert;
